import { render } from "./CustomSizeSelector.vue?vue&type=template&id=5906f083&scoped=true&lang=true"
import script from "./CustomSizeSelector.vue?vue&type=script&lang=js"
export * from "./CustomSizeSelector.vue?vue&type=script&lang=js"

import "./CustomSizeSelector.vue?vue&type=style&index=0&id=5906f083&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.8.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5906f083"]])

export default __exports__